/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Checkbox } from 'semantic-ui-react';

import * as AppActions from '../../../actions';

class WrapperAdCheckbox extends Component {
  onAdSelect = (e, data) => {
    const id = data.id;
    const name = data.name;
    const html_url = data.value;
    const { html_width, html_height } = data.extra;
    let selectedAds = this.props.selectedAds;

    if (data.checked) {
      selectedAds.push({ id, name, html_url, html_width, html_height });
    } else {
      selectedAds = selectedAds.filter((val) => val.id !== id);
    }

    this.props.handleSelectAd(selectedAds);
    e.preventDefault();
    e.stopPropagation();
    return false;
  };
  isAdChecked = (id) => {
    const ad = this.props.selectedAds.filter((val) => val.id === id);
    return ad.length > 0;
  };
  render() {
    if (this.props.showCheckboxes) {
      const {
        id,
        title,
        html_url,
        html_width,
        html_height
      } = this.props.adPreview;
      return (
        <Checkbox
          checked={this.isAdChecked(id)}
          className="select-ad"
          type="checkbox"
          onChange={this.onAdSelect}
          name={title}
          id={id}
          value={html_url}
          extra={{ html_width, html_height }}
        />
      );
    }
    return null;
  }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrapperAdCheckbox);



// WEBPACK FOOTER //
// ./src/screens/AdImport/AdImportComponents/WrapperAdCheckbox.js